<form
  class="p-grid mu-flex-dir-column mu-position-relative mu-form-content mu-auth-information-basic-form"
  [formGroup]="formData"
  (submit)="sendSms()"
  appValidator
>
  <div class="p-grid container-form">
    <app-mu-form-fieldset [customGridColMd]="4" [customGridCol]="4" [customGridColLg]="3" class="mu-fieldset-countries">
      <p-dropdown
        class="phone-dropdown"
        id="countryId"
        name="countryId"
        formControlName="country"
        appRegisterValidator
        [options]="countriesList"
        (onChange)="changeCountry()"
        (onShow)="validatorService?.scrollToSelected(changeDetectorRef, formData, 'countryId', countriesList)"
      >
        <ng-template pTemplate="item" let-country>
          <div class="mu-dropdown-icon-content">
            <div class="mu-dropdown-icon">
              <img src="assets/layout/images/flags/{{ country.icon }}.svg" alt="mu-flags" />
              <img class="mu-dropdown-icon-active" src="assets/layout/images/flags/{{ country.icon }}.svg" alt="mu-flags" />
            </div>
            <div class="mu-dropdown-icon-text">+{{ country.label }}</div>
          </div>
        </ng-template>
        <ng-template let-country pTemplate="selectedItem"
          ><img src="assets/layout/images/flags/{{ country?.icon }}.svg" alt="mu-flags" /> +{{ country?.label }}</ng-template
        >
      </p-dropdown>
    </app-mu-form-fieldset>
    <app-mu-form-fieldset [iconFeedback]="true" [customGridColMd]="8" [customGridCol]="8" [customGridColLg]="9" [slimPadding]="true">
      <app-mu-form-input
        [allowOnlyNumbers]="true"
        [controlName]="'clientPhone'"
        [formData]="formData"
        [editableMask]="true"
        [iconCheck]="!formData?.get('isInvalidForm').value"
        [maxLength]="10"
        [placeholder]="'form.placeholder.phoneNumber' | translate"
      ></app-mu-form-input>
    </app-mu-form-fieldset>
  </div>

  <p-button
    muButtonRight
    type="submit"
    class="mu-button mu-without-padding mu-auth-button"
    [label]="'form.button.sendSms' | translate"
    iconPos="left"
    [disabled]="formData?.get('isInvalidForm').value"
  >
    <app-loading [showLoading]="showLoginLoading" type="icon"></app-loading>
  </p-button>
</form>
